/*
 * SAM utils
 */

import axios from 'axios'
import ENV from '@src/env'

const utils = function (params) {
  return {
    methods: {
      requestFlowAtion: function (body, token) {
        const baseRappi = ENV.rappi.url[this.userEnv]
        return axios.post(
          `${baseRappi}/support-actions-manager/flow-actions/execute`,
          body, {
            headers: {
              Authorization: 'Bearer ' + token
            },
          }
        )
      },
    },
  }
}

export default utils
